/// FOURJS_START_COPYRIGHT(D,2014)
/// Property of Four Js*
/// (c) Copyright Four Js 2014, 2026. All Rights Reserved.
/// * Trademark of Four Js Development Tools Europe Ltd
///   in the United States and elsewhere
///
/// This file can be modified by licensees according to the
/// product manual.
/// FOURJS_END_COPYRIGHT

"use strict";

modulum("StyleNode", ["NodeBase", "NodeFactory"], function (context, cls) {
  /**
   * @class StyleNode
   * @memberOf classes
   * @extends classes.NodeBase
   */
  class StyleNode extends cls.NodeBase /** @lends classes.StyleNode.prototype */ {
    /* jshint ignore:start */
    static _pseudoSelectorsPriority = {
      focus: 1024,
      query: 512,
      display: 256,
      input: 128,
      even: 64,
      odd: 32,
      inactive: 16,
      active: 8,
      message: 4,
      error: 2,
      summaryLine: 1
    };
    /* jshint ignore:end */

    constructor(parent, tag, id, attributes, app) {
      super(parent, tag, id, attributes, app);

      this._parsedElementType = null;
      this._parsedStyleName = null;
      this._parsedPseudoSelectors = null;
      /** @type {number} */
      this._weight = 0;
      /** @type {number} */
      this._pseudoSelectorWeight = 0;

      const name = this.attribute("name");
      const dotIndex = name.indexOf(".");
      const colonIndex = name.indexOf(":");
      this._parsedStyleName = "";
      if (dotIndex === -1 && colonIndex === -1) {
        // ElementType || *
        this._parsedElementType = name;
        this._weight = name === "*" ? 1 : 2;
      } else if (dotIndex !== -1 && colonIndex === -1) {
        // ElementType.stylename || .stylename
        this._parsedElementType = name.substring(0, dotIndex);
        this._parsedStyleName = name.substring(dotIndex + 1);
        this._weight = !this._parsedElementType.length ? 3 : 6;
      } else if (dotIndex === -1 && colonIndex !== -1) {
        // ElementType:pseudoselector || :pseudoselector
        this._parsedElementType = name.substring(0, colonIndex);
        this._parsedPseudoSelectors = name.substring(colonIndex).split(":").splice(1).sort();
        this._weight = !this._parsedElementType.length ? 4 : 5;
      } else {
        // ElementType.stylename:pseudoselector || .stylename:pseudoselector
        this._parsedElementType = name.substring(0, dotIndex);
        this._parsedStyleName = name.substring(dotIndex + 1, colonIndex);
        this._parsedPseudoSelectors = name.substr(colonIndex).split(":").splice(1).sort();
        this._weight = !this._parsedElementType.length ? 7 : 8;
      }
      this._parsedPseudoSelectors = this._parsedPseudoSelectors || [];
      for (const pseudoSelector of this._parsedPseudoSelectors) {
        this._pseudoSelectorWeight += cls.StyleNode._pseudoSelectorsPriority[pseudoSelector];
      }
    }

    getPseudoSelectors() {
      return this._parsedPseudoSelectors;
    }

    getWeight() {
      return this._weight;
    }

    getPseudoSelectorWeight() {
      return this._pseudoSelectorWeight;
    }

    matches(node) {
      let isMatching = true;
      if (this._parsedElementType.length !== 0) {
        isMatching = this._parsedElementType === "*" || this._parsedElementType === node.getTag();
      }
      if (isMatching && this._parsedStyleName.length !== 0) {
        const styleNames = node.attribute("style");
        if (styleNames) {
          isMatching = styleNames.split(" ").indexOf(this._parsedStyleName) !== -1;
        } else {
          isMatching = false;
        }
      }
      return isMatching;
    }

    populateMatchingStyles(matchingAttributesByPseudoSelectors, node) {
      if (this.getRawChildren().length && this.matches(node)) {
        let psKey = "";
        if (this._parsedPseudoSelectors.length) {
          psKey = ":" + this._parsedPseudoSelectors.join(":");
        }
        let dict = matchingAttributesByPseudoSelectors[psKey];
        if (!dict) {
          dict = {};
          matchingAttributesByPseudoSelectors[psKey] = dict;
        }
        for (const child of this._children) {
          const childName = child.attribute("name");
          const styleAttribute = dict[childName];
          if (!styleAttribute || styleAttribute.getParentNode()._weight < this._weight) {
            dict[childName] = child;
          }
        }
      }
    }
  }
  cls.StyleNode = StyleNode;
  cls.NodeFactory.register("Style", cls.StyleNode);
});
